export default "__VITE_ASSET__CfH1wK5x__"